module.exports = __webpack_public_path__ + "static/media/can-flag.d4c026ef.svg";